import { set } from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { PositionStatus } from 'types';

interface Props {
	tab: string;
	AllpositionsCount: number;
	myPositionsCount: number;
	onChange: (value: string) => void;

}

const PositionsTabsComponent = ({
	tab,
	AllpositionsCount,
	myPositionsCount,
	onChange,
}: Props) => {
	const location = useLocation();

	// console.log("tab",tab)

	return (
		<>
			<div className="flex w-full md:w-max dark:bg-[#1F2A37]">
				<button
					className={`${tab==="allPosition"
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={()=>{onChange("allPosition")}}
				>
					All Positions ({AllpositionsCount})
				</button>
				<button
					className={` ${tab==="myPosition"
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-3 sm:flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={()=>{onChange("myPosition")}}
				>
					My Positions ({myPositionsCount})
				</button>
			</div>
		</>
	);
};

export default PositionsTabsComponent;
